import type { FC } from 'react';
import type { Filters } from '../../../hooks/products';

/**
 * A filter child component that declares which `Filters` field it controls.
 * `FiltersPopover` reads this off each rendered child to derive — without a
 * hand-maintained parallel list — the field set the active-filter badge counts
 * and "Clear all" resets.
 */
export type FilterComponent<P = Record<string, never>> = FC<P> & { field: keyof Filters };

/** Tags a filter component with the `Filters` field it owns. */
export function withFilterField<P>(field: keyof Filters, Component: FC<P>): FilterComponent<P> {
  return Object.assign(Component, { field });
}
